import {s_char} from "../../_signals/s_char";
import {Item} from "../CharStyled";
import React from "react";

export default function Karma() {
    return <Item>
        <div>Karma verw:</div>
        {s_char.value.karma_used}
    </Item>
}